import { render, staticRenderFns } from "./apostille.vue?vue&type=template&id=140d0408&"
import script from "./apostille.vue?vue&type=script&lang=js&"
export * from "./apostille.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports